import AsyncStorage from '@react-native-async-storage/async-storage';
import { AreaState } from '../../contexts/reducers/AreaReducer';

export const STORAGE_AUTH_ALIAS = '@Area';

export const GetAreaStorage = async (id: number): Promise<AreaState> => {
  const farm = await AsyncStorage.getItem(`${STORAGE_AUTH_ALIAS}_${id}`);
  return !!farm ? JSON.parse(farm) : null;
};

export const SetAreaStorage = async (id: number, farmState: AreaState) => {
  await AsyncStorage.setItem(`${STORAGE_AUTH_ALIAS}_${id}`, JSON.stringify(farmState));
};

export const DeleteAreaStorage = async (id: number) => {
  await AsyncStorage.removeItem(`${STORAGE_AUTH_ALIAS}_${id}`);
};
